export default {
  'common.empty': '',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.home': 'Home page',
  'common.display': 'Display',
  'common.entries': 'in each page total {total} items',
  'common.form.required': 'Please enter',
  'common.delete': 'Delete',
  'common.share': 'Share',
  'common.listen': 'To listen',
  'common.statusActive': 'Active',
  'common.add': 'Add',
  'common.edit': 'Update',
  'common.all': 'All',
  'common.keyword': 'Key word',
  'common.statusDeactive': 'Stop operation',
  'common.button.accept': 'Confirm',
  'common.button.resend.link': 'Resend Link',
  'common.button.return': 'Come back',
  'link.return.login': 'Back to the login page',
  'common.valid.required': 'Please fill out',
  'common.valid.whitespace': 'Please do not enter white space',
  'common.valid.email': 'Must be in the format',
  'common.deviceType': 'Type of device',
  'common.email': 'Email address',
  'common.volumn': 'Set up volume',
  'common.powerOn': 'Open source',
  'common.powerOff': 'Power off',
  'common.refresh': 'Restart',
  'common.update': 'Update',
  'common.continue': 'Continue',
  'common.management': 'Manage',
  'common.formNote': 'Are mandatory information field',
  'common.active': 'Active',
  'common.deactive': 'Stop operation',
  'common.status': 'Status',
  'common.statusNotApproval': 'Not approval',
  'common.statusReject': 'Refuse',
  'common.invalid': 'Malformed.',
  'common.input.placeholder': 'Please enter {label}',
  'common.status.param': '{status,select, 0 {Unproven} 1 {Approved} 2 {Refuse} other {Unknown}}',
  'common.status.new': 'Not approved',
  'common.status.approval': 'Approved',
  'common.approval': 'Approve',
  'common.file-back': 'Recall',
  'common.back': 'Come back',
  'common.statusConnect': 'Connecting',
  'common.statusDisconnect': 'Lost connection',
  'common.StatusNewsletterPlaying': 'Being a newsletter',
  'common.StatusNewsletterStop': 'Stop the newsletter',
  'common.goBack': 'Return',
  'common.required.password': 'Please enter a password',
  'common.info': 'Information',
  'dashboard.area': 'Locality',
  'dashboard.radio_device': 'Radio equipment',
  'dashboard.mtc_device': 'Public electronics',
  'dashboard.audio_news': 'Radio newsletter',
  'dashboard.mtc_news': 'Public electronic newsletter',
  'area.placeholder': 'Please enter the name of the area',
  'common.remove': 'Erase',
  'common.play': 'Play',
  'common.stt': 'No',
  'common.detail': 'Detail',
  'common.non.title': 'Action',
  'common.turnOn': 'On',
  'common.turnOff': 'Turn off',
  'common.pause': 'Stop playing',
  'common.convert': 'Convert',
  'common.using': 'Using',
  'common.notUse': 'Not yet used',
  'common.check': 'Save',
  'common.close': 'Close',
  'common.noti': 'Notify',
  'common.viewPlus': 'See more',
  'common.return': 'Come back',
  'common.search.placeholder': 'Enter keywords to search',
  'common.eye': 'Display',
  'common.eyeOff': 'Hide',
  'common.hidden': 'Not displayed',
  'common.in.process': 'Uploading',
  'common.logout': 'Logout',
  'common.logout.title': 'Confirm logout',
  'common.logout.content': 'Do you really want to log out?',
  'common.change.password': 'Change password',
  'common.report': 'Report',
  'common.page': 'Page',
  'common.answers': 'Answers',
  'common.search': 'Search',
  'common.action': 'Action',

  'common.profile': 'Profile',
  'common.forgotPassword': 'Forgot password',
  'common.transactions': 'Inventory',
  'common.product': 'Product',
  'common.today': 'Today',
  'common.file': 'Export file',
  'common.checkAll': 'Select all',
  'common.update.user': 'Edit profile',
  'common.update.change-password': 'Change the password',
  'common.check-in': 'Checkin',
  'common.not-check-in': 'Not checkin',
  'common.LifeBuoy': 'CheckIn diary',
  'common.total': 'Total',
  'common.accept': 'Accept',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.choose-file': 'Choose file',
  'common.recall': 'Recall',
  'common.import': 'Import file',
  'common.normal': 'Normal',
  'common.prioritize': 'Prioritize',
  'common.upload.title': 'Drag or drop file',
  'common.upload.content.one': 'Only 1 file',
  'common.ok': 'Ok',
  'common.lengthMax255': 'The length exceeds 255 characters',
  'common.import-voucher': 'Voucher import management',
  'common.print': 'Export list',
  'common.week': 'Week',
  'common.to': 'to',
  'common.notPermission': 'Not have access',
  'common.notPermission.admin': 'Please contact Admin for access',
  'common.from': 'from',
  'common.error': 'Error',
  'common.noError': 'Normal',
  'common.other': 'Other',
  'common.voucherPartner': 'Partner',
  'common.voucherPartner.type': '{type, select, 1 {Momo} 3 {Mega} other {Unknown}}',
  'common.voucherPartner.type.momo': 'Momo',
  'common.voucherPartner.type.mega': 'Mega',
  'common.minute': 'minute',
  'common.hour': 'hour',
  'common.day': 'day',
  'common.export': 'Export file',
  VoucherTypesRedeem: 'Redeem voucher',
  VoucherTypesAvailable: 'View available voucher list',
  VoucherTypesReceivedCustomer: 'View the list of customers who received vouchers',
};
